<template>
  <div class="ma-4">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-skeleton-loader class="mx-auto" type="table" />
    </v-sheet>
    <div v-show="!showSkeleton" class="text-h4 mb-2">Centros de Custo</div>
    <v-data-iterator
      v-show="!showSkeleton"
      :no-data-text="noDataText"
      :items="dataCentroDeCusto"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :no-results-text="noResultsText"
      hide-default-footer
    >
      <template v-slot:header>
        <v-row>
          <v-col cols="7" class="my-2">
            <v-btn
              dark
              color="orangePcm"
              href="/pabx/cadastro/centrodecustos/criar"
              target="_blank"
              @click="handleGoToNewCentroDeCusto"
            >
              Criar Centro de Custo
            </v-btn>
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="search" clearable hide-details prepend-inner-icon="mdi-magnify" label="Busca" />
          </v-col>
        </v-row>
      </template>
      <template v-slot:default="props">
        <v-data-table
          dense
          :headers="headers"
          :items="props.items"
          hide-default-footer
          class="elevation-1"
          disable-pagination
          @dblclick:row="atualizar"
        >
          <template v-slot:[`item.botoes`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  dark
                  color="bluePcm"
                  class="ma-2"
                  :href="`/pabx/cadastro/centrodecustos/atualizar/${item._id}`"
                  target="_blank"
                  v-bind="attrs"
                  v-on="on"
                  @click="atualizarButton(item, $event)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="deletar(item)" icon small dark color="darkRed" v-bind="attrs" v-on="on">
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>Remover</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <div class="ml-4 mb-2 grey--text">
            <p>Total de Centros de Custo: {{ qtdCentroDeCusto }}</p>
          </div>
          <v-spacer />
          <div class="pb-5">
            <ListPagination
              :page="page"
              :numberOfPages="numberOfPages"
              @firstPage="firstPage"
              @formerPage="formerPage"
              @nextPage="nextPage"
              @lastPage="lastPage"
            />
          </div>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import ListPagination from '@/componentes/ListPagination'
import { registerVuexModule } from '@/utils/vuexUtils'
import { pagesHomeMixins } from '@/mixins/pagesHomeMixins'

import centroDeCustosStore from '../_store'
import CentroDeCustoHttpService from '../_services/CentroDeCustoHttpService'

export default {
  components: { ListPagination },

  mixins: [pagesHomeMixins],

  data: () => ({
    headers: [
      {
        text: 'Centro de Custo',
        value: 'description',
        align: 'left',
      },
      {
        text: 'Código',
        value: 'codigo',
        align: 'left',
      },
      {
        text: 'Ações',
        value: 'botoes',
        align: 'center',
        sortable: false,
      },
    ],
    dataCentroDeCusto: [],
  }),

  computed: {
    ...mapGetters('centroDeCustoHomeModulePABXStore', ['getCentroDeCustos']),

    numberOfPages() {
      return Math.ceil(this.dataCentroDeCusto.length / this.itemsPerPage)
    },
    qtdCentroDeCusto() {
      return this.dataCentroDeCusto.length
    },
  },

  async created() {
    registerVuexModule(this.$store, 'centroDeCustoHomeModulePABXStore', centroDeCustosStore)

    await this.listarCentroDeCustos()
    this.dataCentroDeCusto = [...this.getCentroDeCustos]
    this.showSkeleton = false
  },

  methods: {
    ...mapActions('centroDeCustoHomeModulePABXStore', ['listarCentroDeCustos']),

    handleGoToNewCentroDeCusto(event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const handleGoToNewCentroDeCusto = this.$router.resolve({ name: 'Centrodecustos/criar' })
        window.open(handleGoToNewCentroDeCusto.href, '_blank')
      } else {
        this.$router.push({ name: 'Centrodecustos/criar' })
      }
    },

    atualizar(event, item) {
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`centrodecustos/atualizar/${item.item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`centrodecustos/atualizar/${item.item._id}`)
      }
    },

    atualizarButton(item, event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`centrodecustos/atualizar/${item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`centrodecustos/atualizar/${item._id}`)
      }
    },

    async deletar(item) {
      let resultado = window.confirm(`Deseja remover o centro de custo "${item.description}"?`)
      if (resultado) {
        try {
          await CentroDeCustoHttpService.deleteCentroDeCustos(item._id)
          this.dataCentroDeCusto = this.dataCentroDeCusto.filter(x => x._id !== item._id)
        } catch (error) {
          alert(error.response.data)
        }
      }
    },
  },
}
</script>
